import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import JobPublishedImage from "../../../../assets/images/create-job-final-step-figure.png";
import { ListItemIcon, SubscribeButtonIcon } from "../../../../assets/icons/go-hire-page-icons";

const JobPublished = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.jobPublished" });

  const keyFeatures = [
    t("designCustomStages"),
    t("assignChannels"),
    t("addEvaluationTools"),
    t("collaborateWithYourScoutingNetwork"),
    t("trackProgressAndDocumentEvaluations"),
  ];

  return (
    <Box sx={styles.container} component="section">
      <Box sx={styles.content}>
        <Box component="img" sx={styles.image} src={JobPublishedImage} alt="Job Published" />
        <Typography sx={styles.title}>{t("congratulationYourJobPublished")}</Typography>
        <Typography sx={styles.description}>{t("takeYourHiringToTheNextLevel")}</Typography>
      </Box>
      <Box sx={styles.featuresContainer}>
        <Box sx={styles.featuresTitleContainer}>
          <Typography sx={styles.featuresTitle}>{t("proFeatures")}</Typography>
          <Typography sx={styles.featuresSubtitle}>{t("unlockAdvancedHiringTools")}</Typography>
          <Typography sx={styles.featuresDescription}>{t("accessPowerfulRecruitmentFeatures")}</Typography>
        </Box>
        <Typography sx={styles.keyFeaturesTitle}>{t("keyFeatures")}</Typography>
        <Box component="ul" sx={styles.keyFeaturesList}>
          {keyFeatures.map((feature) => (
            <Box component="li" sx={styles.listItemsContainer}>
              <ListItemIcon />
              <Typography sx={styles.listText}>{feature}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default JobPublished;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "633px",
    margin: "10px auto",
    gap: "24px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #344054)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center",
  },
  description: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    textAlign: "center",
  },
  image: {
    width: "107px",
    height: "102px",
  },
  subscribeButton: {
    padding: "10px 32px",
    borderRadius: "999px",
    border: "1px solid #D0D5DD",
    background: "linear-gradient(269deg, #9D00EC 0.55%, #1F3693 98.76%), #FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    color: "var(--White, #FFF) !important",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  featuresContainer: {
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #EAECF0)",
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    background:
      "linear-gradient(180deg, rgba(157, 0, 236, 0.08) 0%, rgba(157, 0, 236, 0.00) 30.21%, rgba(157, 0, 236, 0.00) 100%), #FFF",
  },
  featuresTitleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "6px",
  },
  featuresTitle: {
    color: "var(--goalngo-colors-goalngo-colors-r-157-g-0-b-236, #9D00EC)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 12px",
    borderRadius: "16px",
    border: "1px solid #F1D6FF",
    background: "#FCF5FF",
  },
  featuresSubtitle: {
    fontFamily: "Montserrat",
    color: "var(--black-100, #1C1C1C)",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
  featuresDescription: {
    fontFamily: "Montserrat",
    color: "var(--Gray-Gray-700, #5E6278)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  keyFeaturesTitle: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #101828)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  keyFeaturesList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  listItemsContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  listText: {
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "14 vcccpx",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
};
